import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/regimenPhase";

export const pagingRegimenPhases = (searchObject) => {
  var url = API_PATH + "/pagingRegimenPhases";
  return axios.post(url, searchObject);
};

export const getRegimenPhase = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createRegimenPhase = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editRegimenPhase = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteRegimenPhase = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const checkCode = (obj) => {
  let url = API_PATH + "/checkCode";
  return axios.post(url, obj);
};
